module.exports = __webpack_public_path__ + "static/img/banner.e26dfed.png";


//////////////////
// WEBPACK FOOTER
// ./static/aboutUs/banner.png
// module id = DJZn
// module chunks = 1